module.exports = __webpack_public_path__ + "close-f48b1585839f49a82cd5.svg";